module.exports = __webpack_public_path__ + "img/16.1886a05f.jpg";